import { Component, OnInit }   from '@angular/core';
import { Router }  from '@angular/router';
import { FormDataService } from '../service/form/form-data.service';
import { ComponentBase } from '../base/component-base';
import { FormGroup } from '@angular/forms';
import { UtilService } from '../service/util.service';
import { ISelectionBox } from '../model/ISelectionBox';
import { CookiesLocalService } from '../service/cookies-local.service';
import { IGuardian } from '../model/IGuardian';
import { ApplicantService } from '../service/applicant.service';
import { BehaviorModelChangeService } from '../service/behavior-model-change.service.service';

@Component({
  selector: 'app-personal-guardian-info',
  templateUrl: './personal-guardian-info.component.html',
  styleUrls: ['./personal-guardian-info.component.css']
})
export class PersonalGuardianInfoComponent extends ComponentBase implements OnInit {
  title = 'Please tell us about yourself.';
  personalGuardianInfo: FormGroup;
  occupations: ISelectionBox[];
  relationships: ISelectionBox[];
  regions: ISelectionBox[];
  guardianData: IGuardian;


  constructor(private router: Router, private formDataService: FormDataService, private utilService: UtilService
    ,         cookieLocal: CookiesLocalService,
              applicantService: ApplicantService, behaviorModelChangeService: BehaviorModelChangeService) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  ngOnInit() {

    const app = this.applicantData;

    this.guardianData = this.cookieLocal.getGuardianData();
    this.personalGuardianInfo = this.formDataService.getGuardianInfo(this.guardianData);



    this.applicantService.getApplicationGuardianData(app.GuardianId).subscribe(model => {

        this.guardianData = this.cookieLocal.getRefreshedGuardianData(model);
        this.personalGuardianInfo = this.formDataService.getGuardianInfo(this.guardianData);
    });



    this.getLoadData();
  }
  getLoadData() {
    this.utilService.getRegions().subscribe(data => { this.regions = data.map(item => {
          return {ValueId: item.ValueId, DisplayValue: item.DisplayValue.toUpperCase()};
      });
    });

    this.utilService.getOccupations().subscribe(data => { this.occupations = data.map(item => {
          return {ValueId: item.ValueId, DisplayValue: item.DisplayValue.toUpperCase()};
      });
    });
    this.utilService.getRelationships().subscribe(data => { this.relationships = data.map(item => {
          return {ValueId: item.ValueId, DisplayValue: item.DisplayValue.toUpperCase()};
      });
    });
  }
  save(form: any): boolean {
    if (!form.valid) {
      return false;
    }

    return true;
  }

  goToNext(form: any) {
    if (this.save(form)) {

      this.formDataService.setGuardianInfo(this.personalGuardianInfo.value);

      if (this.isPostgraduateStudent()) {
        this.router.navigate(['/applicant/info/post-univ']);
      } else {
        this.router.navigate(['/applicant/info/exam-info']);
      }
    }
  }

  goToPrevious(form: any) {
    this.router.navigate(['/applicant/info/personal/contact']);
  }
}
